export default __webpack_public_path__ + "static/media/logo-afp.a2739e7b.png";